import {
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Button,
} from "@mui/material";
import { Link } from "react-router-dom";
import { products } from "../data/products";

function Categories() {
  const categories = Object.entries(products)?.map(([id, category]) => ({
    id,
    ...category,
  }));

  return (
    <Container sx={{ py: 6 }}>
      <Typography variant="h3" component="h1" gutterBottom align="center">
        Kategoriler
      </Typography>

      <Typography variant="body1" paragraph align="center" sx={{ mb: 6 }}>
        Tekstil baskı çözümlerimiz ile tanışın
      </Typography>

      <Grid container spacing={4}>
        {categories.map((category) => (
          <Grid item key={category.id} xs={12} sm={6} md={4}>
            <Card
              sx={{ height: "100%", display: "flex", flexDirection: "column" }}
            >
              <CardMedia
                component="img"
                height="200"
                image={category.items[0].image}
                alt={category.title}
              />
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography gutterBottom variant="h5" component="h2">
                  {category.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                  {category.description}
                </Typography>
                <Button
                  component={Link}
                  to={`/category/${category.id}`}
                  variant="contained"
                  color="primary"
                  fullWidth
                >
                  Detayları Gör
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default Categories;
